import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
enum CardDIField {
  name = 'name',
  issuer = 'issuer',
  number = 'number',
  numberLast4 = 'number_last4',
  cvc = 'cvc',
  expiration = 'expiration',
  expirationMonth = 'expiration_month',
  expirationYear = 'expiration_year',
  zip = 'billing_address.zip',
  country = 'billing_address.country',
  fingerprint = 'fingerprint',
}
enum BankDIField {
  name = 'name',
  accountType = 'account_type',
  routingNumber = 'ach_routing_number',
  accountNumber = 'ach_account_number',
  accountId = 'ach_account_id',
  fingerprint = 'fingerprint',
  institutionName = 'institution_name',
  linkId = 'link_id',
  institutionId = 'institution_id',
  accountLast4 = 'account_last4',
  owners = 'owners',
}
const useGetTranslationWithoutAlias = () => {
  const $ = _c(71);
  const {
    t
  } = useTranslation("common");
  let t0;
  if ($[0] !== t) {
    t0 = t(_temp);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t(_temp2);
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t(_temp3);
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t(_temp4);
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t(_temp5);
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t(_temp6);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t(_temp7);
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t(_temp8);
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t(_temp9);
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp10);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t(_temp11);
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t0 || $[23] !== t1 || $[24] !== t10 || $[25] !== t2 || $[26] !== t3 || $[27] !== t4 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t11 = {
      [CardDIField.name]: t0,
      [CardDIField.issuer]: t1,
      [CardDIField.number]: t2,
      [CardDIField.numberLast4]: t3,
      [CardDIField.cvc]: t4,
      [CardDIField.expiration]: t5,
      [CardDIField.expirationMonth]: t6,
      [CardDIField.expirationYear]: t7,
      [CardDIField.zip]: t8,
      [CardDIField.country]: t9,
      [CardDIField.fingerprint]: t10
    };
    $[22] = t0;
    $[23] = t1;
    $[24] = t10;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const cardTranslations = t11;
  let t12;
  if ($[34] !== t) {
    t12 = t(_temp12);
    $[34] = t;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t) {
    t13 = t(_temp13);
    $[36] = t;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t) {
    t14 = t(_temp14);
    $[38] = t;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t) {
    t15 = t(_temp15);
    $[40] = t;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t) {
    t16 = t(_temp16);
    $[42] = t;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t) {
    t17 = t(_temp17);
    $[44] = t;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t) {
    t18 = t(_temp18);
    $[46] = t;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t) {
    t19 = t(_temp19);
    $[48] = t;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t) {
    t20 = t(_temp20);
    $[50] = t;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t) {
    t21 = t(_temp21);
    $[52] = t;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== t) {
    t22 = t(_temp22);
    $[54] = t;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t12 || $[57] !== t13 || $[58] !== t14 || $[59] !== t15 || $[60] !== t16 || $[61] !== t17 || $[62] !== t18 || $[63] !== t19 || $[64] !== t20 || $[65] !== t21 || $[66] !== t22) {
    t23 = {
      [BankDIField.name]: t12,
      [BankDIField.accountType]: t13,
      [BankDIField.routingNumber]: t14,
      [BankDIField.accountNumber]: t15,
      [BankDIField.accountId]: t16,
      [BankDIField.fingerprint]: t17,
      [BankDIField.institutionName]: t18,
      [BankDIField.linkId]: t19,
      [BankDIField.institutionId]: t20,
      [BankDIField.accountLast4]: t21,
      [BankDIField.owners]: t22
    };
    $[56] = t12;
    $[57] = t13;
    $[58] = t14;
    $[59] = t15;
    $[60] = t16;
    $[61] = t17;
    $[62] = t18;
    $[63] = t19;
    $[64] = t20;
    $[65] = t21;
    $[66] = t22;
    $[67] = t23;
  } else {
    t23 = $[67];
  }
  const bankTranslations = t23;
  let t24;
  if ($[68] !== bankTranslations || $[69] !== cardTranslations) {
    t24 = key => {
      const parts = key.split(".");
      if (parts.length < 3) {
        return key;
      }
      const [type,, ...fieldParts] = parts;
      const fieldKey = fieldParts.join(".");
      if (type === "card") {
        return cardTranslations[fieldKey as CardDIField] || key;
      }
      if (type === "bank") {
        return bankTranslations[fieldKey as BankDIField] || key;
      }
      return key;
    };
    $[68] = bankTranslations;
    $[69] = cardTranslations;
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  return t24;
};
export default useGetTranslationWithoutAlias;
function _temp($) {
  return $.di.card.name;
}
function _temp2($_0) {
  return $_0.di.card.issuer;
}
function _temp3($_1) {
  return $_1.di.card.number;
}
function _temp4($_2) {
  return $_2.di.card.number_last4;
}
function _temp5($_3) {
  return $_3.di.card.cvc;
}
function _temp6($_4) {
  return $_4.di.card.expiration;
}
function _temp7($_5) {
  return $_5.di.card.verbose.expiration_month;
}
function _temp8($_6) {
  return $_6.di.card.verbose.expiration_year;
}
function _temp9($_7) {
  return $_7.di.card.verbose["billing_address.zip"];
}
function _temp10($_8) {
  return $_8.di.card.verbose["billing_address.country"];
}
function _temp11($_9) {
  return $_9.di.card.fingerprint;
}
function _temp12($_10) {
  return $_10.di.bank.name;
}
function _temp13($_11) {
  return $_11.di.bank.account_type;
}
function _temp14($_12) {
  return $_12.di.bank.ach_routing_number;
}
function _temp15($_13) {
  return $_13.di.bank.ach_account_number;
}
function _temp16($_14) {
  return $_14.di.bank.ach_account_id;
}
function _temp17($_15) {
  return $_15.di.bank.fingerprint;
}
function _temp18($_16) {
  return $_16.di.bank.institution_name;
}
function _temp19($_17) {
  return $_17.di.bank.link_id;
}
function _temp20($_18) {
  return $_18.di.bank.institution_id;
}
function _temp21($_19) {
  return $_19.di.bank.account_last4;
}
function _temp22($_20) {
  return $_20.di.bank.owners;
}